import { useEffect, useState } from "react";
import heroImage from "../assets/hero2.png";
import { Link } from "react-router-dom";

export default function HeroSection() {
  const [customers, setCustomers] = useState(0);
  const [rating, setRating] = useState(0);
  const [delivery, setDelivery] = useState(0);

  useEffect(() => {
    animate(setCustomers, 1000);
    animate(setRating, 4.9, true);
    animate(setDelivery, 30);
  }, []);

  const animate = (setter, end, decimal = false) => {
    let startTime = null;
    const duration = 1200;

    const step = (time) => {
      if (!startTime) startTime = time;
      const progress = Math.min((time - startTime) / duration, 1);
      const value = end * progress;
      setter(decimal ? value.toFixed(1) : Math.floor(value));
      if (progress < 1) requestAnimationFrame(step);
    };

    requestAnimationFrame(step);
  };

  return (
    <section className="w-full min-h-screen bg-red-700 overflow-hidden flex flex-row-reverse items-center">
      <div className="max-w-7xl mx-auto px-6 lg:px-16 w-full flex flex-col-reverse lg:grid lg:grid-cols-2 gap-1 lg:gap-14 items-center">
        {/* Left Content */}
        <div>
          <h1 className="font-light sm:font-thin text-3xl sm:text-4xl md:text-6xl text-white leading-snug sm:leading-tight">
            Freshly Baked
            <br />
            <span className="text-amber-500 font-light sm:font-thin">
              Delivered Hot
            </span>
          </h1>

          <p className="mt-6 max-w-md font-light sm:font-thin text-base sm:text-lg md:text-xl leading-relaxed tracking-wide text-gray-300">
            Premium ingredients, oven-baked perfection, and lightning-fast
            delivery — every single time.
          </p>

          <div className="mt-10 flex gap-4 flex-wrap">
            <Link to="/menu">
              <button className="px-8 py-3 rounded-full bg-amber-500 text-black font-light sm:font-thin hover:bg-amber-600 transition text-sm lg:text-base">
                Order Now
              </button>
            </Link>
            <Link to="/contact">
              <button className="px-8 py-3 rounded-full border border-white/30 text-white font-light sm:font-thin hover:bg-white/10 transition text-sm lg:text-base">
                contact Us
              </button>
            </Link>
          </div>

          {/* Stats */}
          <div className="mt-12 flex gap-8 sm:gap-10 text-gray-300 text-sm sm:text-base tracking-wide flex-wrap">
            <div>
              <p className="text-white text-center font-light sm:font-thin text-xl sm:text-2xl md:text-3xl">
                {customers.toLocaleString()}+
              </p>
              <p className="font-light sm:font-thin w-max text-xs sm:text-sm">
                Happy Customers
              </p>
            </div>
            <div>
              <p className="text-white text-center font-light sm:font-thin text-xl sm:text-2xl md:text-3xl">
                {rating} ★
              </p>
              <p className="font-light sm:font-thin w-max text-xs sm:text-sm">
                Average Rating
              </p>
            </div>
            <div>
              <p className="text-white text-center font-light sm:font-thin text-xl sm:text-2xl md:text-3xl">
                {delivery} min
              </p>
              <p className="font-light sm:font-thin w-max text-xs sm:text-sm">
                Fast Delivery
              </p>
            </div>
          </div>
        </div>

        {/* Right Pizza Image */}
        <div className="flex justify-center mb-10 lg:mb-0">
          <img
            src={heroImage}
            alt="Pizza"
            className="w-[300px] sm:w-[400px] lg:w-[500px] drop-shadow-md animate-float transition-transform duration-300"
          />
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="hidden absolute bottom-2 md:bottom-5 lg:bottom-10 left-1/2 -translate-x-1/2 lg:flex flex-col items-center text-gray-400 text-sm">
        <span className="mb-2 font-light sm:font-thin">Scroll</span>
        <div className="w-6 h-10 border border-white/30 rounded-full flex justify-center">
          <div className="w-1 h-2 bg-white rounded-full mt-2 animate-scroll"></div>
        </div>
      </div>
    </section>
  );
}
